<style scoped lang="less">
/deep/ .el-form-item {
	display: flex;
	align-items: center;
	.el-form-item__content {
		width: 90%;
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #fff;
	margin-bottom: 20px;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	// button:last-child {
	// 	background-color: #ff8300;
	// }

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}
.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
		color: #333;
		font-weight: 600 !important;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}
</style>
<template>
	<div>
		<titles titlename="我的媒体类型" titlecontent="这里可以看到我的媒体类型" :mbx="paths"></titles>
		<div
			class="resourbtn"
			@click="
				dialogFormVisible = true;
				title = '添加考核等级';
				gwname = '';
				rtguid = '';
			"
		>
			<el-button type="primary" size="small" icon="fa fa-plus">添加内容</el-button>
		</div>
		<el-dialog :title="title" :before-close="handleClose" :visible.sync="dialogFormVisible" center label-width="80px">
			<el-form :model="form">
				<el-form-item label="资源名称"><el-input v-model="gwname" autocomplete="off" placeholder="请输入资源名称"></el-input></el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="affprlist">确 定</el-button>
			</div>
		</el-dialog>
		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column label="序号" type="index" :index="indexMethod" width="50"></el-table-column>
							<el-table-column label="资源名称" prop="RT_ResourceTitle"></el-table-column>
							<el-table-column label="操作" fixed="right" width="300px">
								<template slot-scope="scope">
									<el-button
										size="mini"
										style="background-color: #17a2b8;"
										@click="
											dialogFormVisible = true;
											title = '修改考核等级';
											gwname = scope.row.RT_ResourceTitle;
											rtguid = scope.row.RT_GUID;
										"
									>
										编辑
									</el-button>
									<!-- <el-popconfirm title="是否删除该条记录？">
										<el-button slot="reference" plain size="mini" style="background-color: #ec0f25;">删除</el-button>
									</el-popconfirm> -->
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ tableData.length }}</span>
						,共
						<span>{{ tableData.length }}</span>
						条记录
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { getGetResourceTypes, UpdateResourceType, AddResource } from '@/request/api/homesview/yunhomes/yunhom.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/homesview/resource/mediatype',
					name: '媒体类型管理'
				}
			],
			tabsnum: 10,
			totalall: 10,
			tabindex: 1,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1
			},
			tabsnun: 1,
			tableData: [],
			title: '添加考核等级',
			dialogFormVisible: false,
			form: {
				name: ''
			},
			gwname: '',
			rtguid: '',
			formLabelWidth: '120px'
		};
	},
	components: {
		titles
	},
	mounted() {
		this.get();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		indexMethod(index) {
			return index + 1;
		},
		get() {
			getGetResourceTypes().then(res => {
				this.tableData = res.data.data;
			});
		},
		addproli() {
			let ceTyper = {
				RT_ResourceTitle: this.gwname,
				RT_ResourceCode: ''
			};
			AddResource(ceTyper).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.dialogFormVisible = false;
					this.get();
				}
			});
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		affprlist() {
			if (this.rtguid == '') {
				this.addproli();
			} else {
				let ceTyper = {
					RT_ResourceTitle: this.gwname,
					RT_GUID: this.rtguid
				};
				UpdateResourceType(ceTyper).then(res => {
					if (res.data.code > 0) {
						this.$message.success(res.data.msg);
						this.get();
						this.dialogFormVisible = false;
					}
				});
			}
		}
	}
};
</script>
